<template>
    <div>
        <div class="row gutter-sm q-mb-lg">
            <div class="col-xs-12 col-sm-12 q-mt-lg">
                <span class="q-headline text-weight-light">{{ $t('basic_data') }}</span>
            </div>

            <div class="col-xs-12 col-sm-12">
                <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch"  :disable="showDisable"/>
            </div>

            <div class="col-xs-12 col-sm-12">
                <q-select v-model="reward_campaign" :options="reward_campaigns.map(e => ({label: e.title, value: e.id}))" :float-label="$t('campaign')" :error="$v.reward_campaign.$error" @input="$v.reward_campaign.$touch" :disable="showDisable" />
            </div>

            <div class="col-xs-12 col-sm-12">
                <p class="caption">{{ $t('image') }}</p>
                <uploader content_type="images" @fileUploaded="imageUploaded" :multiple="false" :cropper="true"   :disable="showDisable" />

                <p v-if="image" class="q-mt-md file-url">
                    <q-icon name="fal fa-check" color="positive" />
                    <a :href="image_url_complete" target="_blank"> {{ $truncateLink(image) }}</a>
                </p>
            </div>

            <div class="col-xs-12 col-sm-12">
                <q-input v-model="short_description" :float-label="$t('short_description')" :error="$v.short_description.$error" @input="$v.short_description.$touch"  :disable="showDisable"/>
            </div>

            <div class="col-12">
                <q-select v-model="timezone" :options="timezones" :float-label="$t('timezone')" filter :error="$v.timezone.$error" @input="$v.timezone.$touch" :disable="showDisable" />
            </div>

            <div class="col-xs-12 col-sm-6">
                <q-datetime v-model="start_date" type="datetime" :float-label="$t('start_date')" format="DD/MM/YYYY HH:mm:ss" :error="$v.start_date.$error" @input="$v.start_date.$touch"  :disable="showDisable" />
            </div>

            <div class="col-xs-12 col-sm-6">
                <q-datetime v-model="end_date" type="datetime" :float-label="$t('end_date')" format="DD/MM/YYYY HH:mm:ss" :error="$v.end_date.$error" @input="$v.end_date.$touch"  :disable="showDisable"/>
            </div>

            <div class="col-xs-12 col-sm-12">
                <q-input v-model="checkin_score" type="number" :float-label="$t('score')" :error="$v.checkin_score.$error" @input="$v.checkin_score.$touch" :disable="showDisable"/>
            </div>

            <div class="col-xs-12 col-sm-12">
                <p class="caption">{{ $t('description') }}</p>
                <q-editor
                    :style="getErrorColorEditor($v.description.$error)"
                    :disable="showDisable"
                    :error="$v.description.$error" @input="$v.description.$touch"
                    v-model="description"
                    :toolbar="[
                        ['bold', 'italic', 'strike', 'underline'],
                        ['left', 'center', 'right', 'justify'],
                        ['link', 'upload'],
                        [
                            {
                                label: null,
                                icon: 'fas fa-font',
                                fixedLabel: true,
                                fixedIcon: true,
                                list: 'no-icons',
                                options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code']
                            },
                            {
                                label: null,
                                icon: 'fas fa-text-height',
                                fixedLabel: true,
                                fixedIcon: true,
                                list: 'no-icons',
                                options: ['size-1', 'size-2', 'size-3', 'size-4', 'size-5', 'size-6', 'size-7']
                            },
                            'removeFormat'
                        ],
                        ['quote', 'unordered', 'ordered'],
                        ['custom_btn']
                    ]"
                    :definitions="{
                        bold: {label: null, icon: 'fas fa-bold'},
                        italic: {label: null, icon: 'fas fa-italic'},
                        strike: {label: null, icon: 'fas fa-strikethrough'},
                        underline: {label: null, icon: 'fas fa-underline'},
                        left: {label: null, icon: 'fas fa-align-left'},
                        center: {label: null, icon: 'fas fa-align-center'},
                        right: {label: null, icon: 'fas fa-align-right'},
                        justify: {label: null, icon: 'fas fa-align-justify'},
                        link: {label: null, icon: 'fas fa-link'},
                        upload: { tip: null, icon: 'fas fa-file-image', handler: insertImg },
                        removeFormat: {label: null, icon: 'fas fa-eraser'},
                        quote: {label: null, icon: 'fas fa-quote-right'},
                        unordered: {label: null, icon: 'fas fa-list-ul'},
                        ordered: {label: null, icon: 'fas fa-list-ol'}
                    }"
                >
                <q-btn
                    slot="custom_btn"
                    dense
                    flat
                    color="black"
                    icon="fal fa-code"
                    label="HTML"
                    @click="show_html = true"
                />
                </q-editor>
            </div>

            <div class="col-xs-12 col-sm-12 q-mt-lg">
                <span class="q-headline text-weight-light">{{ $t('address') }}</span>
            </div>

            <div v-if="keyGooogleMaps" class="col-xs-12 col-sm-12" >
                <q-field :error="show_maps_alert" :error-label="$t('not_found_check_that_the_search_is_spelled_correctly_and_try_to_add_a_street_address_and_the_number_of_valid_addresses')">
                    <q-input v-model="address" :float-label="$t('address')" autocomplete="new-password"  :error="$v.address.$error" @input="$v.address.$touch" :placeholder="$t('search_by_name_and_street_number')  :disable="showDisable"">
                        <q-autocomplete
                            @search="getAddressGoogleMaps"
                            :min-characters="3"
                            @selected="selectedAddressGoogleMaps"
                            separator
                        />
                    </q-input>
                </q-field>
            </div>

            <div v-else class="col-xs-12 col-sm-12">
                <q-input v-model="address" :float-label="$t('address')"  :error="$v.address.$error" @input="$v.address.$touch" autocomplete="new-password"  :disable="showDisable">
                    <q-autocomplete
                        @search="getAddress"
                        :min-characters="3"
                        @selected="selectedAddress"
                        separator
                    />
                </q-input>
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="number" :float-label="$t('number')" ref="number" :error="$v.number.$error" @input="$v.number.$touch"  :disable="showDisable" />
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="complement" :float-label="$t('complement')"  :disable="showDisable"/>
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="neighborhood" :float-label="$t('neighborhood')"  :disable="showDisable"/>
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="postal_code" :float-label="$t('postal_code')"  :disable="showDisable"/>
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="country" :float-label="$t('country')" :error="$v.country.$error" @input="$v.country.$touch" :disable="showDisable" />
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="state" :float-label="$t('state')" :error="$v.state.$error" @input="$v.state.$touch"   :disable="showDisable"/>
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="city" :float-label="$t('city')"  :error="$v.city.$error" @input="$v.city.$touch"  :disable="showDisable"/>
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="lat" type="number" :float-label="$t('latitude')" :disable="showDisable" />
            </div>

            <div class="col-xs-12 col-sm-4">
                <q-input v-model="long" type="number" :float-label="$t('longitude')" :disable="showDisable" />
            </div>

            <div class="col-xs-12 col-sm-4 flex  items-end justify-center">
                <q-btn @click="showMap()" :disabled="disabledButton"  class='full-width' color="primary"  icon="map" :label="$t('see_on_map')"/>
            </div>

            <div class="col-xs-12 col-sm-12 q-mt-lg">
                <span class="q-headline text-weight-light">{{ $t('permission') }}</span>
            </div>

        </div>

        <q-tabs v-model="tab" color="secondary" class="shadow-1">
            <q-tab slot="title" name="permissions" icon="fal fa-clipboard-list-check" :label="$t('permissions')" />
            
            <q-tab-pane name="permissions" class="q-px-lg q-pb-xl">
                <div class="row gutter-sm">
                    <div class="col-xs-12 col-sm-12">
                        <q-select v-model="area" :options="areas" :float-label="$t('areas')" :error="$v.area.$error" @input="$v.area.$touch" multiple chips  :disable="showDisable" />
                    </div>

                    <div class="col-xs-12 col-sm-12">
                        <p class="caption">{{ $t('profiles') }}</p>

                        <div class="row gutter-sm">
                            <div class="col-xs-12 col-sm-12">
                                <q-checkbox v-model="all_profiles" :val="true" :label="$t('all')" @input="checkAll()"  :disable="showDisable" />
                            </div>

                            <div class="col-xs-12 col-sm-4" v-for="(item, index) in profiles" :key="index" :class="getErrorClass($v.profile.$error)">
                                <q-checkbox keep-color v-model="profile" :val="item.value" :label="item.label" @input="$v.profile.$touch" :color="getErrorColor($v.profile.$error)"  :disable="showDisable" />
                            </div>

                            <div class="col-xs-12 col-sm-12">
                                <q-select v-model="reward_level" :options="getReward_levels" :float-label="$t('user_level')" :error="$v.reward_level.$error" @input="$v.reward_level.$touch"  multiple chips  :disable="showDisable" />
                            </div>
                        </div>
                    </div>
                </div>
            </q-tab-pane>
        </q-tabs>

        <div class="row gutter-sm q-my-sm">
            <div class="col-xs-12 col-sm-12">
                <p class="caption">{{ $t('status') }}</p>
                <q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="statuses"   :disable="showDisable"/>
            </div>
        </div>

        <q-modal v-model="show_html" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_html = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        HTML
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row">
                        <div class="col-12">
                            <q-input type="textarea" rows="10" float-label="HTML" v-model="description" />
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="tertiary" class="full-width" :label="$t('close')" icon="far fa-ban" @click="show_html = false" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'events' })" />
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { date } from 'quasar'
const { formatDate, buildDate } = date
import Uploader from 'components/Uploader'
import { OpenStreetMapProvider } from 'leaflet-geosearch'
import * as moment from 'moment'
import * as tz from 'moment-timezone'
import { BlobServiceClient } from '@azure/storage-blob'

const provider = new OpenStreetMapProvider({
    params: {
        addressdetails: '1'
    }
})

export default {
    components: {
        'uploader': Uploader,
    },

    data() {
        return {
            show_maps_alert: false,
            show_html: false,
            tab_content: "events",
            tab: "permissions",
            all_profiles: false,
            statuses: [
                { label: this.$t('published'), value: 1 },
                { label: this.$t('unpublished'), value: 2 },
                { label: this.$t('finished'), value: 4 }
            ],
            id_event: 0,
            title: '',
            description: '',
            short_description: '',
            start_date: '',
            end_date: '',
            area: [],
            profile: [],
            reward_level: [],
            image: '',
            image_url_complete: '',
            checkin_score: 0,
            status: 2,
            address: '',
            number: '',
            complement: '',
            neighborhood: '',
            postal_code: '',
            city: '',
            state: '',
            country: '',
            lat: '',
            long: '',
            timezone: '',
            reward_campaign: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            areas: 'registration_lists/country_areas',
            reward_levels: 'registration_lists/reward_levels',
            profiles: 'registration_lists/profiles',
            tags: 'registration_lists/tags',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            user_clients: 'common/user_clients',
            timezones: 'registration_lists/timezones',
            reward_campaigns: 'registration_lists/reward_campaigns'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        getColorStatus() {
            if (this.status == 1) return 'positive'
            else if (this.status == 2) return 'negative'
            else return 'info'
        },

        addressRequired() {
            if (this.address || this.city || this.state || this.country || this.lat ||this.long || this.number) return true
            else return false
        },

        keyGooogleMaps() {
            return process.env.KEY_GOOGLE_API
        },

        disabledButton(){
            if(this.lat == null || this.lat == "" || this.long == null || this.long == "" ) return 'disabled'
        },

        showDisable() {
            if(this.status == 4) return true
            else return false
        },

        getReward_levels() {
            if(this.reward_levels) {
                return this.reward_levels.map(r => {
                    return {
                        "label": this.$t(r.label),
                        "value": r.value
                    }
                })
            }
        }
    },

    methods: {
        saveData() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let data = {}
                data.start_date = moment(date.formatDate(this.start_date, 'YYYY-MM-DDTHH:mm')).tz(this.timezone, true).format('YYYY-MM-DDTHH:mm:ssZ')
                data.end_date = moment(date.formatDate(this.end_date, 'YYYY-MM-DDTHH:mm')).tz(this.timezone, true).format('YYYY-MM-DDTHH:mm:ssZ')
                data.title = this.title
                data.status = this.status
                data.checkin_score = this.checkin_score
                data.timezone = this.timezone
                data.reward_campaign = this.reward_campaign

                data.address = {
                    address: this.address,
                    number: this.number,
                    complement: this.complement ,
                    neighborhood: this.neighborhood,
                    postal_code: this.postal_code,
                    city: this.city,
                    state: this.state,
                    country: this.country
                }

                if (this.lat) data.address.lat = this.lat
                if (this.long) data.address.long = this.long

                if (this.description) data.description = this.description
                if (this.short_description) data.short_description = this.short_description
                if (this.image) data.image = this.image

                if (this.area.length > 0 && this.profile.length > 0) {
                    data.areas = this.area
                    data.profiles = this.profile
                }

                if (this.reward_level.length > 0) {
                    data.reward_levels = this.reward_level
                }

                if (this.id_event != 0) {
                    this.$axios.put(`/admin_rewards/events_qrcode/${this.id_event}/`, data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('save_data_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.$router.push({ name: 'events' })
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        console.log(e)
                    })
                }
                else {
                    this.$axios.post(`/admin_rewards/events_qrcode/`, data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('save_data_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })

                        this.$router.push({ name: 'event', params: { id: response.data.id }})
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        console.log(e)
                    })
                }
            }
            else {
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        fetchData() {
            this.$q.loading.show()
            this.$axios.get(`/admin_rewards/events_qrcode/${this.id_event}/`, this.getHeader)
            .then(response => {
                this.title = response.data.title
                this.checkin_score = response.data.checkin_score
                this.description = response.data.description == null ? "" : response.data.description
                this.short_description = response.data.short_description
                this.image = response.data.image

                this.start_date = response.data.start_date
                this.end_date = response.data.end_date

                this.address = response.data.address.address
                this.number = response.data.address.number
                this.complement = response.data.address.complement
                this.neighborhood = response.data.address.neighborhood
                this.postal_code = response.data.address.postal_code
                this.city = response.data.address.city
                this.state = response.data.address.state
                this.country = response.data.address.country
                this.lat = response.data.address.lat
                this.long = response.data.address.long

                this.timezone = response.data.timezone

                this.status = response.data.status
                this.profile = response.data.profiles
                this.area = response.data.areas
                this.reward_level = response.data.reward_levels
                this.reward_campaign = response.data.reward_campaign

                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        imageUploaded(url) {
            this.image = url
            this.image_url_complete = url
        },

        insertImg() {
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = '.png, .jpg, .gif'
            let file

            input.onchange = _ => {
                const files = Array.from(input.files)
                file = files[0]

                this.uploadFile(file)

            }
            input.click()
        },

        uploadFile (file) {
            let date = moment()

            let fd = new FormData()
            fd.append('filename', file.name)
            fd.append('file_directory', `media/html_images/events/${date.year()}/${date.month() + 1}/`)

            this.$axios.post('/api/files/policy/', fd, this.getHeader)
            .then(response => {
                return new Promise((resolve) => {
                    this.$q.loading.show()

                    if (response.data.origin === 'azure') {
                        const blobServiceClient = new BlobServiceClient(
                            `${response.data.base_url}?${response.data.sas_token}`
                        )

                        const main = async () => {
                            const container_client = blobServiceClient.getContainerClient('')

                            const block_blob_client = container_client.getBlockBlobClient(response.data.filename)
                            const upload_blob_response = await block_blob_client.uploadBrowserData(file)

                            let fd_complete = new FormData()
                            fd_complete.append('uploaded', true)
                            fd_complete.append('fileSize', file.size)
                            fd_complete.append('file', response.data.file_id)

                            if (this.custom_directory) {
                                fd_complete.append('not_signed', true)
                                fd_complete.append('bucket_name', 'static')
                            }

                            this.$axios.post('/api/files/complete/', fd_complete, this.getHeader)
                            .then(response => {
                                this.fileUrl = response.data.fileUrl
                                document.execCommand('insertHTML', true, '<div><img class="uploadBase" src="' + this.fileUrl + '" style="max-width: 100%" /></div>')
                            })
                            .finally(() => {
                                resolve()
                                this.$q.loading.hide()
                            })
                        }

                        main()
                    }
                    else {
                        let content_type = file.type != '' ? file.type : 'application/octet-stream'
                        let policy = response.data
                        let file_name = policy.filename
                        let key_path = policy.file_bucket_path

                        let fd_s3 = new FormData()
                        fd_s3.append('key', key_path + file_name)
                        fd_s3.append('acl','private')
                        fd_s3.append('Content-Type', content_type)
                        fd_s3.append("AWSAccessKeyId", policy.key)
                        fd_s3.append('Policy', policy.policy)
                        fd_s3.append('filename', file_name)
                        fd_s3.append('Signature', policy.signature)
                        fd_s3.append('file', file)

                        this.cancel_token = this.$axios.CancelToken
                        this.source = this.cancel_token.source()

                        this.$axios.post(process.env.BUCKET_URL, fd_s3,
                        {
                            // onUploadProgress: function( event ) {
                            //     updateProgress(event.loaded / event.total)
                            // },
                            // cancelToken: this.source.token

                        })
                        .then(response => {
                            let fd_complete = new FormData()
                            fd_complete.append('uploaded', true)
                            fd_complete.append('fileSize', file.size)
                            fd_complete.append('file', policy.file_id)

                            this.$axios.post('/api/files/complete/', fd_complete, this.getHeader)
                            .then(response => {
                                let data = {
                                    file_url: response.data.fileUrl
                                }

                                this.$axios.post('/utils/presigned_url/', data, this.getHeader)
                                .then(response => {
                                    document.execCommand('insertHTML', true, `<div><img class="uploadBase" src="${response.data.file_url}" style="max-width: 100%" /></div>`)
                                })
                                .catch(e => {
                                    console.log(e)
                                })
                                .finally(() => {
                                    this.$q.loading.hide()
                                })
                            })
                            .finally(() => {
                                this.$q.loading.hide()
                            })
                        })
                        .finally(() => {
                            resolve()
                        })
                    }
                })
            })
            .catch(e => {
                console.log(e)
                this.$q.loading.hide()
            })
        },

        checkAll() {
            if (this.all_profiles) {
                this.profiles.forEach(element => {
                    this.profile.push(element.value)
                })
            }
            else {
                this.profile = []
            }
        },

        getErrorColor(state) {
            if (state) return 'negative'
            else return ''
        },

        getErrorColorEditor(state) {
            if (state) return 'border: 1px solid #db2828'
            else return ''
        },

        getErrorClass(state) {
            if (state) return 'checkbox-error'
            else return ''
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        getAddress(terms, done) {
            provider.search({ query: terms })
            .then((result) => {
                done(result)
            })
        },

        selectedAddress(item) {
            this.$nextTick(() => this.address = item.raw.address.road)

            this.postal_code = ""
            this.city = ""
            this.state = ""
            this.lat = ""
            this.long = ""
            this.country = ""


            this.postal_code = item.raw.address.postcode
            this.city = item.raw.address.city
            this.state = item.raw.address.state
            this.lat = item.raw.lat
            this.long = item.raw.lon
            this.country = item.raw.address.country


            if (item.raw.address.neighbourhood) {
                this.neighborhood = item.raw.address.neighbourhood
            }

            else if (item.raw.address.suburb) {
                this.neighborhood = item.raw.address.suburb
            }
            else if (item.raw.address.city_district) {
                this.neighborhood = item.raw.address.city_district
            }

            this.$nextTick(() => this.$refs.number.$el.focus())
        },

        getAddressGoogleMaps(terms,done){
            this.$axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${terms}&key=${this.keyGooogleMaps}`)
            .then(response => {
                if(response.data.results.length > 0){
                    this.option_address = response.data.results
                    let teste = response.data.results.map(e => ({label: e.formatted_address, value: e.formatted_address, place_id: e.place_id}))
                    done(teste)
                }else{
                    this.show_maps_alert = true
                }
            })
            .catch(e => {
                console.log(e)
            })
        },

        selectedAddressGoogleMaps(item) {
            this.show_maps_alert = false
            this.address = ''
            this.number = ''
            this.neighborhood = ''
            this.postal_code = ''
            this.city = ''
            this.state = ''
            this.option_address.map (x =>{
                if(x.place_id === item.place_id) {
                    this.lat = x.geometry.location.lat
                    this.long = x.geometry.location.lng
                    x.address_components.map(e => {
                        switch(e.types[0]) {
                        case 'route':
                            this.address = e.long_name
                            break;
                        case 'street_number':
                            this.number = e.long_name
                            break;
                        case 'political':
                        case 'administrative_area_level_4':
                            this.neighborhood = e.long_name
                            break;
                        case 'postal_code':
                            this.postal_code = e.long_name
                            break;
                        case 'country':
                            this.country = e.country
                            break;
                        case 'administrative_area_level_2':
                            this.city = e.long_name
                            break;
                        case 'administrative_area_level_1':
                            this.state = e.long_name
                            break;
                        }
                    })
                }
            })
        },

        showMap() {
            if (this.$q.platform.is.cordova && this.$q.platform.is.ios) {
                cordova.InAppBrowser.open(`http://maps.google.com/?q=${this.lat},${this.long}`, '_system', 'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no')
            }
            else {
                window.open(`http://maps.google.com/?q=${this.lat},${this.long}`, '_blank')
            }
        },

        fetchTimezones() {
            let values = []

            moment.tz.names()
            .reduce((memo, tz) => {
                memo.push({
                    name: tz,
                    offset: moment.tz(tz).utcOffset()
                })

                return memo
            }, [])
            .sort((a, b) => {
                return a.offset - b.offset
            })
            .reduce((memo, tz) => {
                const timezone = tz.offset ? moment.tz(tz.name).format('Z') : ''
                values.push({ value: tz.name, label: `(GMT${timezone}) ${tz.name}`, ...tz })
            }, '')

            this.$store.dispatch('registration_lists/SET_TIMEZONES', [values])
        }
    },

    created() {
        this.fetchTimezones()

        this.id_event = this.$route.params.id
        if (this.id_event != 0){
            this.fetchData()
        }
        else {
            this.timezone = moment.tz.guess()
        }
    },

    validations() {
        return {
            title: { required },
            start_date: { required },
            end_date: { required },
            short_description: { required },
            description: { required },
            checkin_score: { required },
            area: {
                requiredIf: requiredIf(() => {
                    if(this.area.length == 0) return true
                    else return false
                })
            },
            profile: {
                requiredIf: requiredIf(() => {
                    if(this.profile.length == 0) return true
                    else return false
                })
            },
            reward_level: {
                requiredIf: requiredIf(() => {
                    if(this.reward_level.length == 0) return true
                    else return false
                })
            },
            country: {
                requiredIf: requiredIf(() => {
                    return this.addressRequired
                })
            },
            address: {
                requiredIf: requiredIf(() => {
                    return this.addressRequired
                })
            },
            city: {
                requiredIf: requiredIf(() => {
                    return this.addressRequired
                })
            },
            state: {
                requiredIf: requiredIf(() => {
                    return this.addressRequired
                })
            },
            number: {
                requiredIf: requiredIf(() => {
                    return this.addressRequired
                })
            },
            timezone: { required },
            reward_campaign: { required }
        }
    }
}
</script>

<style>

</style>